// src/plantsData.js - Complete Nursery Plant Database
export const plantCategories = [
  {
    id: 'vegetables',
    name: 'Vegetables',
    image: 'https://cdn.pixabay.com/photo/2017/10/09/19/29/eat-2834549_640.jpg',
    plants: [
      {
        id: 'tomato',
        name: 'Tomato',
        image: 'https://cdn.pixabay.com/photo/2011/03/16/16/01/tomatoes-5356_640.jpg',
        varieties: [
          { name: 'Solan Gola Yashwant', image: 'https://www.syngenta.co.in/sites/g/files/kgtney376/files/styles/global_search_thumbnail/public/media/image/2022/01/14/to_2174_edit.jpg?itok=oYtOyDpt' },
          { name: 'Solan Vajr', image: 'https://www.global-agriculture.com/wp-content/uploads/2022/10/Untitled-1-39-768x427.jpg' },
          { name: 'Solan Shagun (F1)', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSXiicwQvOr7nORTtsNY3ZEWibLgdawMrlMRw&s' },
          { name: 'UHF-55 Naveen', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRvgtn_IA-Uds9ce29C3-0UeT0bjENsaV-DJw&s' },
          { name: 'Rupali', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRFQbBlnG_vKCdl67VEHjLnJwOG6b5b5QVxdXXg3an-QGSkK-50DDFXHY_MTGWAjCEhcAc&usqp=CAU' },
          { name: 'MTH-15', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTGW2Bo4DlFFkO8THzQ0UMtq0515n4pClIglA&s' },
          { name: 'Him Palam Tomato Hybrid-2', image: 'https://cdn.pixabay.com/photo/2016/08/01/17/08/tomatoes-1561565_640.jpg' },
          { name: 'Amisha', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcShinESfKPzfRCctt0Q-AIQjn51muKcqztmWA&s' },
          { name: 'Naveen 2000+', image: 'https://cdn.pixabay.com/photo/2016/08/01/17/08/tomatoes-1561565_640.jpg' },
          { name: 'BSS-366', image: 'https://cdn.pixabay.com/photo/2016/08/01/17/08/tomatoes-1561565_640.jpg' },
          { name: 'Solan Red Round', image: 'https://cdn.pixabay.com/photo/2016/08/01/17/08/tomatoes-1561565_640.jpg' }
        ]
      },
      {
        id: 'cucumber',
        name: 'Cucumber',
        image: 'https://cdn.pixabay.com/photo/2016/04/13/07/18/cucumber-1326678_640.jpg',
        varieties: [
          { name: 'Khira-75', image: 'https://cdn.pixabay.com/photo/2016/04/13/07/18/cucumber-1326678_640.jpg' },
          { name: 'Khira-90', image: 'https://cdn.pixabay.com/photo/2016/04/13/07/18/cucumber-1326678_640.jpg' },
          { name: 'Pusa Sanyog', image: 'https://cdn.pixabay.com/photo/2016/04/13/07/18/cucumber-1326678_640.jpg' },
          { name: 'Him Palam Kheera-1', image: 'https://cdn.pixabay.com/photo/2016/04/13/07/18/cucumber-1326678_640.jpg' },
          { name: 'Kheera-2', image: 'https://cdn.pixabay.com/photo/2016/04/13/07/18/cucumber-1326678_640.jpg' },
          { name: 'Solan Srijan', image: 'https://cdn.pixabay.com/photo/2016/04/13/07/18/cucumber-1326678_640.jpg' }
        ]
      },
      {
        id: 'cabbage',
        name: 'Cabbage',
        image: 'https://cdn.pixabay.com/photo/2017/10/15/11/41/cabbage-2854942_640.jpg',
        varieties: [
          { name: 'Kinner Red', image: 'https://cdn.pixabay.com/photo/2017/10/15/11/41/cabbage-2854942_640.jpg' },
          { name: 'Pride of India', image: 'https://cdn.pixabay.com/photo/2017/10/15/11/41/cabbage-2854942_640.jpg' },
          { name: 'Large Late Drum Head', image: 'https://cdn.pixabay.com/photo/2017/10/15/11/41/cabbage-2854942_640.jpg' },
          { name: 'Golden Acre', image: 'https://cdn.pixabay.com/photo/2017/10/15/11/41/cabbage-2854942_640.jpg' },
          { name: 'Him Palam Cabbage Hybrid-1', image: 'https://cdn.pixabay.com/photo/2017/10/15/11/41/cabbage-2854942_640.jpg' }
        ]
      },
      {
        id: 'cauliflower',
        name: 'Cauliflower',
        image: 'https://cdn.pixabay.com/photo/2018/10/03/21/57/cauliflower-3722494_640.jpg',
        varieties: [
          { name: 'Snow Ball-16', image: 'https://cdn.pixabay.com/photo/2018/10/03/21/57/cauliflower-3722494_640.jpg' },
          { name: 'PSB-1 (Pusa Snow Ball-1)', image: 'https://cdn.pixabay.com/photo/2018/10/03/21/57/cauliflower-3722494_640.jpg' }
        ]
      },
      {
        id: 'capsicum',
        name: 'Capsicum (Bell Pepper)',
        image: 'https://cdn.pixabay.com/photo/2016/11/23/00/33/bell-pepper-1851656_640.jpg',
        varieties: [
          { name: 'Solan Bharpur', image: 'https://cdn.pixabay.com/photo/2016/11/23/00/33/bell-pepper-1851656_640.jpg' },
          { name: 'Selection-9', image: 'https://cdn.pixabay.com/photo/2016/11/23/00/33/bell-pepper-1851656_640.jpg' },
          { name: 'Chinese Giant', image: 'https://cdn.pixabay.com/photo/2016/11/23/00/33/bell-pepper-1851656_640.jpg' },
          { name: 'Sweet Banana', image: 'https://cdn.pixabay.com/photo/2016/11/23/00/33/bell-pepper-1851656_640.jpg' },
          { name: 'Hungarian Wax', image: 'https://cdn.pixabay.com/photo/2016/11/23/00/33/bell-pepper-1851656_640.jpg' },
          { name: 'California Wonder', image: 'https://cdn.pixabay.com/photo/2016/11/23/00/33/bell-pepper-1851656_640.jpg' },
          { name: 'Bharath (F1)', image: 'https://cdn.pixabay.com/photo/2016/11/23/00/33/bell-pepper-1851656_640.jpg' },
          { name: 'Yolo Wonder', image: 'https://cdn.pixabay.com/photo/2016/11/23/00/33/bell-pepper-1851656_640.jpg' },
          { name: 'Indira', image: 'https://cdn.pixabay.com/photo/2016/11/23/00/33/bell-pepper-1851656_640.jpg' },
          { name: 'Orobelle', image: 'https://cdn.pixabay.com/photo/2016/11/23/00/33/bell-pepper-1851656_640.jpg' },
          { name: 'Bomby', image: 'https://cdn.pixabay.com/photo/2016/11/23/00/33/bell-pepper-1851656_640.jpg' }
        ]
      },
      {
        id: 'bitter-gourd',
        name: 'Bitter Gourd',
        image: 'https://cdn.pixabay.com/photo/2017/06/02/18/24/bitter-gourd-2367042_640.jpg',
        varieties: [
          { name: 'Solan Hara', image: 'https://cdn.pixabay.com/photo/2017/06/02/18/24/bitter-gourd-2367042_640.jpg' },
          { name: 'Solan Safed', image: 'https://cdn.pixabay.com/photo/2017/06/02/18/24/bitter-gourd-2367042_640.jpg' }
        ]
      },
      {
        id: 'carrot',
        name: 'Carrot',
        image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/carrots-3359759_640.jpg',
        varieties: [
          { name: 'Chantney', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/carrots-3359759_640.jpg' },
          { name: 'Nantes', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/carrots-3359759_640.jpg' },
          { name: 'Solan Rachana', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/carrots-3359759_640.jpg' }
        ]
      },
      {
        id: 'okra',
        name: 'Okra (Bhindi)',
        image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/okra-3359760_640.jpg',
        varieties: [
          { name: 'Pusa Sawani', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/okra-3359760_640.jpg' },
          { name: 'Harbhajan', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/okra-3359760_640.jpg' }
        ]
      },
      {
        id: 'turnip',
        name: 'Turnip',
        image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/turnip-3359761_640.jpg',
        varieties: [
          { name: 'PTWG', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/turnip-3359761_640.jpg' }
        ]
      },
      {
        id: 'radish',
        name: 'Radish',
        image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/radish-3359762_640.jpg',
        varieties: [
          { name: 'Japanese White', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/radish-3359762_640.jpg' },
          { name: 'Chinese Pink', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/radish-3359762_640.jpg' },
          { name: 'Him Palam Mooli No. 1', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/radish-3359762_640.jpg' }
        ]
      },
      {
        id: 'spinach',
        name: 'Spinach',
        image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/spinach-3359763_640.jpg',
        varieties: [
          { name: 'Long Standing Savoy', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/spinach-3359763_640.jpg' },
          { name: 'Banerjee Giant', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/spinach-3359763_640.jpg' }
        ]
      },
      {
        id: 'brinjal',
        name: 'Brinjal (Eggplant)',
        image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/eggplant-3359764_640.jpg',
        varieties: [
          { name: 'Pusa Purple Long', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/eggplant-3359764_640.jpg' },
          { name: 'Pusa Purple Round', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/eggplant-3359764_640.jpg' },
          { name: 'Arka Manik', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/eggplant-3359764_640.jpg' },
          { name: 'Arka Anand', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/eggplant-3359764_640.jpg' }
        ]
      },
      {
        id: 'onion',
        name: 'Onion',
        image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/onion-3359765_640.jpg',
        varieties: [
          { name: 'N-53', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/onion-3359765_640.jpg' },
          { name: 'Him Palam Shweta', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/onion-3359765_640.jpg' },
          { name: 'Arka Niketan', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/onion-3359765_640.jpg' },
          { name: 'Arka Kalyan', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/onion-3359765_640.jpg' }
        ]
      },
      {
        id: 'peas',
        name: 'Peas',
        image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/peas-3359766_640.jpg',
        varieties: [
          { name: 'Him Palam Matar-1', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/peas-3359766_640.jpg' },
          { name: 'Him Palam Matar-2', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/peas-3359766_640.jpg' },
          { name: 'Him Palam Meethi Phali-1', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/peas-3359766_640.jpg' },
          { name: 'Him Palam Meethi Phali-2', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/peas-3359766_640.jpg' },
          { name: 'Kinnauri', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/peas-3359766_640.jpg' },
          { name: 'Solan Nirog', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/peas-3359766_640.jpg' },
          { name: 'Lincoln', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/peas-3359766_640.jpg' },
          { name: 'Bonneville', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/peas-3359766_640.jpg' },
          { name: 'Azad P-1', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/peas-3359766_640.jpg' },
          { name: 'VL-3', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/peas-3359766_640.jpg' },
          { name: 'VL-7', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/peas-3359766_640.jpg' },
          { name: 'Ageta-6', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/peas-3359766_640.jpg' },
          { name: 'Arkel', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/peas-3359766_640.jpg' },
          { name: 'Pusa Parvati', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/peas-3359766_640.jpg' }
        ]
      },
      {
        id: 'cherry-tomato',
        name: 'Cherry Tomato',
        image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/tomato-3359767_640.jpg',
        varieties: [
          { name: 'Him Palam Cherry Yellow', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/tomato-3359767_640.jpg' }
        ]
      },
      {
        id: 'french-bean',
        name: 'French Bean',
        image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/bean-3359768_640.jpg',
        varieties: [
          { name: 'Lakshmi', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/bean-3359768_640.jpg' },
          { name: 'SVM-1', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/bean-3359768_640.jpg' },
          { name: 'UHFB-30', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/bean-3359768_640.jpg' },
          { name: 'Premier', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/bean-3359768_640.jpg' },
          { name: 'Contender', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/bean-3359768_640.jpg' },
          { name: 'Kentucky Wonder', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/bean-3359768_640.jpg' },
          { name: 'Pusa Parvati', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/bean-3359768_640.jpg' },
          { name: 'Arka Komal', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/bean-3359768_640.jpg' },
          { name: 'Pant Anupama', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/bean-3359768_640.jpg' }
        ]
      },
      {
        id: 'other-veggies',
        name: 'Other Vegetables',
        image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/vegetables-3359769_640.jpg',
        varieties: [
          { name: 'Broccoli', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/broccoli-3359770_640.jpg' },
          { name: 'Asparagus', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/asparagus-3359771_640.jpg' },
          { name: 'Leek', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/leek-3359772_640.jpg' },
          { name: 'Parsley', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/parsley-3359773_640.jpg' },
          { name: 'Swiss Chard', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/swiss-chard-3359774_640.jpg' },
          { name: 'Pak Choi', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/pak-choi-3359775_640.jpg' },
          { name: 'Oriental Mustard', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/mustard-3359776_640.jpg' },
          { name: 'Lettuce (Solan Kriti)', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/lettuce-3359777_640.jpg' }
        ]
      }
    ]
  },
  {
    id: 'fruit-trees',
    name: 'Fruit Trees',
    image: 'https://cdn.pixabay.com/photo/2017/06/02/18/24/fruit-2367029_640.jpg',
    plants: [
      {
        id: 'apple',
        name: 'Apple',
        image: 'https://cdn.pixabay.com/photo/2016/02/23/17/42/apple-1218162_640.jpg',
        varieties: [
          { name: 'Royal Delicious', image: 'https://cdn.pixabay.com/photo/2017/09/26/13/42/apple-2788662_640.jpg' },
          { name: 'Red Delicious', image: 'https://cdn.pixabay.com/photo/2017/09/26/13/31/apple-2788646_640.jpg' },
          { name: 'Golden Delicious', image: 'https://cdn.pixabay.com/photo/2017/09/26/13/42/apple-2788662_640.jpg' },
          { name: 'Scarlet Spur', image: 'https://cdn.pixabay.com/photo/2017/09/26/13/42/apple-2788662_640.jpg' },
          { name: 'Red Chief', image: 'https://cdn.pixabay.com/photo/2017/09/26/13/42/apple-2788662_640.jpg' },
          { name: 'Gala', image: 'https://cdn.pixabay.com/photo/2017/09/26/13/42/apple-2788662_640.jpg' },
          { name: 'Fuji', image: 'https://cdn.pixabay.com/photo/2017/09/26/13/42/apple-2788662_640.jpg' },
          { name: 'Red Fuji', image: 'https://cdn.pixabay.com/photo/2017/09/26/13/42/apple-2788662_640.jpg' },
          { name: 'Anna', image: 'https://cdn.pixabay.com/photo/2017/09/26/13/42/apple-2788662_640.jpg' },
          { name: 'Dorsett Golden', image: 'https://cdn.pixabay.com/photo/2017/09/26/13/42/apple-2788662_640.jpg' },
          { name: 'Michael Schlomit', image: 'https://cdn.pixabay.com/photo/2017/09/26/13/42/apple-2788662_640.jpg' },
          { name: 'Camspur', image: 'https://cdn.pixabay.com/photo/2017/09/26/13/42/apple-2788662_640.jpg' },
          { name: 'Early Red One', image: 'https://cdn.pixabay.com/photo/2017/09/26/13/42/apple-2788662_640.jpg' },
          { name: 'Oregon Spur', image: 'https://cdn.pixabay.com/photo/2017/09/26/13/42/apple-2788662_640.jpg' },
          { name: 'McIntosh', image: 'https://cdn.pixabay.com/photo/2017/09/26/13/42/apple-2788662_640.jpg' },
          { name: 'Chaubattia Anupam', image: 'https://cdn.pixabay.com/photo/2017/09/26/13/42/apple-2788662_640.jpg' },
          { name: 'Lal Ambri', image: 'https://cdn.pixabay.com/photo/2017/09/26/13/42/apple-2788662_640.jpg' },
          { name: 'Granny Smith', image: 'https://cdn.pixabay.com/photo/2017/09/26/13/42/apple-2788662_640.jpg' }
        ]
      },
      {
        id: 'pear',
        name: 'Pear',
        image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/pear-3359778_640.jpg',
        varieties: [
          { name: 'Max Red Bartlett', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/pear-3359778_640.jpg' },
          { name: 'Conference', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/pear-3359778_640.jpg' },
          { name: 'Red Sensation', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/pear-3359778_640.jpg' },
          { name: 'Anjou', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/pear-3359778_640.jpg' },
          { name: 'Shinseiki', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/pear-3359778_640.jpg' },
          { name: 'Nijisseiki', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/pear-3359778_640.jpg' },
          { name: 'Chojuro', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/pear-3359778_640.jpg' },
          { name: 'Hosui', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/pear-3359778_640.jpg' },
          { name: 'Kosui', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/pear-3359778_640.jpg' },
          { name: 'Beurre Hardy', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/pear-3359778_640.jpg' }
        ]
      },
      {
        id: 'cherry',
        name: 'Cherry',
        image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/cherry-3359779_640.jpg',
        varieties: [
          { name: 'Van', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/cherry-3359779_640.jpg' },
          { name: 'Sam', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/cherry-3359779_640.jpg' },
          { name: 'Stella', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/cherry-3359779_640.jpg' },
          { name: 'Sunburst', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/cherry-3359779_640.jpg' },
          { name: 'Lambert', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/cherry-3359779_640.jpg' },
          { name: 'Durone Nero I', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/cherry-3359779_640.jpg' },
          { name: 'Durone Nero II', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/cherry-3359779_640.jpg' },
          { name: 'Durone Nero III', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/cherry-3359779_640.jpg' },
          { name: 'Napoleon', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/cherry-3359779_640.jpg' },
          { name: 'Ranier', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/cherry-3359779_640.jpg' },
          { name: 'Compact Stella', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/cherry-3359779_640.jpg' },
          { name: 'Summit', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/cherry-3359779_640.jpg' },
          { name: 'Sylvia', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/cherry-3359779_640.jpg' },
          { name: 'Schneiders', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/cherry-3359779_640.jpg' }
        ]
      },
      {
        id: 'apricot',
        name: 'Apricot',
        image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/apricot-3359780_640.jpg',
        varieties: [
          { name: 'Harcot', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/apricot-3359780_640.jpg' },
          { name: 'Canino', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/apricot-3359780_640.jpg' },
          { name: 'Taradivo', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/apricot-3359780_640.jpg' },
          { name: 'Angelino Errani', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/apricot-3359780_640.jpg' },
          { name: 'Winatchee', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/apricot-3359780_640.jpg' },
          { name: 'Moorpark', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/apricot-3359780_640.jpg' },
          { name: 'Red Gold', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/apricot-3359780_640.jpg' }
        ]
      },
      {
        id: 'peach',
        name: 'Peach',
        image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/peach-3359781_640.jpg',
        varieties: [
          { name: 'Andros', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/peach-3359781_640.jpg' },
          { name: 'Baby Gold-7', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/peach-3359781_640.jpg' },
          { name: 'Early Elberta', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/peach-3359781_640.jpg' },
          { name: 'Sun Crest', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/peach-3359781_640.jpg' }
        ]
      },
      {
        id: 'plum',
        name: 'Plum',
        image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/plum-3359782_640.jpg',
        varieties: [
          { name: 'Early Prolific', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/plum-3359782_640.jpg' }
        ]
      },
      {
        id: 'walnut',
        name: 'Walnut',
        image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/walnut-3359783_640.jpg',
        varieties: [
          { name: 'Sorrento', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/walnut-3359783_640.jpg' },
          { name: 'Grenoble', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/walnut-3359783_640.jpg' },
          { name: 'Franquette', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/walnut-3359783_640.jpg' },
          { name: 'Hartley', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/walnut-3359783_640.jpg' },
          { name: 'Eureka', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/walnut-3359783_640.jpg' },
          { name: 'Carpathian', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/walnut-3359783_640.jpg' }
        ]
      },
      {
        id: 'hazelnut',
        name: 'Hazelnut',
        image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/hazelnut-3359784_640.jpg',
        varieties: [
          { name: 'Tonda Griffoni', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/hazelnut-3359784_640.jpg' },
          { name: 'Tonda Romana', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/hazelnut-3359784_640.jpg' },
          { name: 'Gentile Della', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/hazelnut-3359784_640.jpg' },
          { name: 'Langhe', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/hazelnut-3359784_640.jpg' },
          { name: 'Barcelona', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/hazelnut-3359784_640.jpg' },
          { name: 'White Heart', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/hazelnut-3359784_640.jpg' },
          { name: 'Melville', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/hazelnut-3359784_640.jpg' }
        ]
      },
      {
        id: 'pistachio',
        name: 'Pistachio',
        image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/pistachio-3359785_640.jpg',
        varieties: [
          { name: 'Napoletana', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/pistachio-3359785_640.jpg' }
        ]
      },
      {
        id: 'fig',
        name: 'Fig',
        image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/fig-3359786_640.jpg',
        varieties: [
          { name: 'White', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/fig-3359786_640.jpg' },
          { name: 'Black', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/fig-3359786_640.jpg' }
        ]
      },
      {
        id: 'olive',
        name: 'Olive',
        image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/olive-3359787_640.jpg',
        varieties: [
          { name: 'Carolea', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/olive-3359787_640.jpg' },
          { name: 'Biancolilla', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/olive-3359787_640.jpg' },
          { name: 'Zaituna', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/olive-3359787_640.jpg' },
          { name: 'Leccino', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/olive-3359787_640.jpg' },
          { name: 'Moraiolo', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/olive-3359787_640.jpg' },
          { name: 'Coratina', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/olive-3359787_640.jpg' },
          { name: 'Pendolino', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/olive-3359787_640.jpg' },
          { name: 'Cipressino', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/olive-3359787_640.jpg' },
          { name: 'Frantoio', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/olive-3359787_640.jpg' },
          { name: 'Nocellara del Belice', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/olive-3359787_640.jpg' },
          { name: 'Nocellara Etnea', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/olive-3359787_640.jpg' },
          { name: 'Tonda Iblea', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/olive-3359787_640.jpg' },
          { name: 'Picholine', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/olive-3359787_640.jpg' },
          { name: 'Dolce di Cerignola', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/olive-3359787_640.jpg' },
          { name: 'Itrana', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/olive-3359787_640.jpg' }
        ]
      },
      {
        id: 'strawberry',
        name: 'Strawberry',
        image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/strawberry-3359788_640.jpg',
        varieties: [
          { name: 'Fern', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/strawberry-3359788_640.jpg' },
          { name: 'Silva', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/strawberry-3359788_640.jpg' },
          { name: 'Brighten', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/strawberry-3359788_640.jpg' },
          { name: 'Douglas', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/strawberry-3359788_640.jpg' },
          { name: 'Chandler', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/strawberry-3359788_640.jpg' },
          { name: 'Pajaro', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/strawberry-3359788_640.jpg' },
          { name: 'Gorella', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/strawberry-3359788_640.jpg' },
          { name: 'Addie', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/strawberry-3359788_640.jpg' },
          { name: 'Confutura', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/strawberry-3359788_640.jpg' }
        ]
      },
      {
        id: 'kiwi',
        name: 'Kiwi',
        image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/kiwi-3359789_640.jpg',
        varieties: [
          { name: 'Allison', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/kiwi-3359789_640.jpg' },
          { name: 'Abbot', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/kiwi-3359789_640.jpg' },
          { name: 'Monty', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/kiwi-3359789_640.jpg' },
          { name: 'Bruno', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/kiwi-3359789_640.jpg' },
          { name: 'Hayward', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/kiwi-3359789_640.jpg' },
          { name: 'Tamori', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/kiwi-3359789_640.jpg' }
        ]
      },
      {
        id: 'almond',
        name: 'Almond',
        image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/almond-3359790_640.jpg',
        varieties: [
          { name: 'Texas', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/almond-3359790_640.jpg' },
          { name: 'Christomorto', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/almond-3359790_640.jpg' },
          { name: 'Tuono', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/almond-3359790_640.jpg' },
          { name: 'Phillipoceo', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/almond-3359790_640.jpg' },
          { name: 'Fragualio', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/almond-3359790_640.jpg' },
          { name: 'Genco', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/almond-3359790_640.jpg' },
          { name: 'Ferraduel', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/almond-3359790_640.jpg' },
          { name: 'Robijn', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/almond-3359790_640.jpg' }
        ]
      },
      {
        id: 'carob',
        name: 'Carob',
        image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/carob-3359791_640.jpg',
        varieties: [
          { name: 'Standard', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/carob-3359791_640.jpg' }
        ]
      }
    ]
  },
  {
    id: 'wild-edibles',
    name: 'Wild & Native Edibles',
    image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/edible-3359792_640.jpg',
    plants: [
      {
        id: 'himalayan-pear',
        name: 'Himalayan Wild Pear',
        image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/pear-3359778_640.jpg',
        varieties: [
          { name: 'Pyrus pashia', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/pear-3359778_640.jpg' }
        ]
      },
      {
        id: 'bayberry',
        name: 'Myrica esculenta (Bayberry/Kaphal)',
        image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/bayberry-3359793_640.jpg',
        varieties: [
          { name: 'Red Flowered', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/bayberry-3359793_640.jpg' },
          { name: 'White Flowered', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/bayberry-3359793_640.jpg' }
        ]
      },
      {
        id: 'edible-mushrooms',
        name: 'Edible Mushrooms',
        image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/mushroom-3359794_640.jpg',
        varieties: [
          { name: 'Morels (Gucchi)', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/mushroom-3359794_640.jpg' },
          { name: 'Oyster', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/mushroom-3359794_640.jpg' },
          { name: 'Reishi', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/mushroom-3359794_640.jpg' },
          { name: 'Lion\'s Mane', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/mushroom-3359794_640.jpg' },
          { name: 'Chanterelle', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/mushroom-3359794_640.jpg' },
          { name: 'Chicken-of-the-Woods', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/mushroom-3359794_640.jpg' }
        ]
      },
      {
        id: 'himalayan-greens',
        name: 'Himalayan Greens',
        image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/greens-3359795_640.jpg',
        varieties: [
          { name: 'Lungdu/Lingdi (Fiddlehead Fern)', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/greens-3359795_640.jpg' },
          { name: 'Watercress', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/greens-3359795_640.jpg' },
          { name: 'Bhatmori', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/greens-3359795_640.jpg' },
          { name: 'Banaksha', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/greens-3359795_640.jpg' },
          { name: 'Bichoo Booti', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/greens-3359795_640.jpg' },
          { name: 'Chabchu', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/greens-3359795_640.jpg' },
          { name: 'Nadde Saag', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/greens-3359795_640.jpg' }
        ]
      }
    ]
  }
];

// Mock data for popular varieties (last month)
export const popularVarieties = [
  { name: 'Royal Delicious Apple', image: 'https://cdn.pixabay.com/photo/2017/09/26/13/42/apple-2788662_640.jpg' },
  { name: 'Solan Gola Yashwant Tomato',  image: 'https://cdn.pixabay.com/photo/2016/08/01/17/08/tomatoes-1561565_640.jpg' },
  { name: 'Him Palam Kheera-1 Cucumber', image: 'https://cdn.pixabay.com/photo/2016/04/13/07/18/cucumber-1326678_640.jpg' },
  { name: 'Golden Acre Cabbage',  image: 'https://cdn.pixabay.com/photo/2017/10/15/11/41/cabbage-2854942_640.jpg' },
  { name: 'Himalayan Wild Pear', image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/pear-3359778_640.jpg' },
  { name: 'Morels (Gucchi)',  image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/mushroom-3359794_640.jpg' },
  { name: 'Solan Bharpur Capsicum',  image: 'https://cdn.pixabay.com/photo/2016/11/23/00/33/bell-pepper-1851656_640.jpg' },
  { name: 'Harcot Apricot',  image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/apricot-3359780_640.jpg' },
  { name: 'Fern Strawberry',  image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/strawberry-3359788_640.jpg' },
  { name: 'Hayward Kiwi',image: 'https://cdn.pixabay.com/photo/2018/04/29/11/54/kiwi-3359789_640.jpg' }
];